import { Component } from "@angular/core";
import { GlobalSettingsVM, CounsellingTopicVM, ReasonForMedicationVM, CountryVM, CallingCodeVM, NationalityVM, WhoAmIVM, LanguageVM } from "../../models";
import { FormGroup, FormArray, FormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import * as $ from 'jquery';
import { BaseHtmlHelperComponent } from "./base.htmlhelper.component";
import { TimeZoneInfoVM } from '../../models/TimeZoneInfoVM';
export class BaseComponent extends BaseHtmlHelperComponent {

  public globalSettings: GlobalSettingsVM;
  public me: WhoAmIVM = new WhoAmIVM();
  public myForm: FormGroup;
  public counsellingTopicList: CounsellingTopicVM[];
  public reasonsForMedicationList: ReasonForMedicationVM[];
  public countryList: CountryVM[];
  public callingCodeList: CallingCodeVM[];
  public stateList: string[];
  public nationalityList: NationalityVM[];
  public languageList: LanguageVM[];

  constructor(private baseRoute: ActivatedRoute) {
    super();
    this.emitDisplayLoadingDialog(false);

    if (this.baseRoute.snapshot.data['globalSettings'] != null) {
      this.globalSettings = this.baseRoute.snapshot.data['globalSettings'];
    }

    if (this.baseRoute.snapshot.data['whoAmI']) {
      this.me = this.baseRoute.snapshot.data['whoAmI'];
    }

    if (this.baseRoute.snapshot.data['countryList'] != null) {
      this.countryList = this.baseRoute.snapshot.data['countryList'];
    }

    if (this.baseRoute.snapshot.data['callingCodeList'] != null) {
      this.callingCodeList = this.baseRoute.snapshot.data['callingCodeList'];
    }

    if (this.baseRoute.snapshot.data['stateList'] != null) {
      this.stateList = this.baseRoute.snapshot.data['stateList'];
    }

    if (this.baseRoute.snapshot.data['nationalityList'] != null) {
      this.nationalityList = this.baseRoute.snapshot.data['nationalityList'];
    }

    if (this.baseRoute.snapshot.data['languageList'] != null) {
      this.languageList = this.baseRoute.snapshot.data['languageList'];
    }

    if (this.baseRoute.snapshot.data['counsellingTopicList'] != null) {
      this.counsellingTopicList = this.baseRoute.snapshot.data['counsellingTopicList'];
    }

    if (this.baseRoute.snapshot.data['reasonsForMedicationList'] != null) {
      this.reasonsForMedicationList = this.baseRoute.snapshot.data['reasonsForMedicationList'];
    }

    window.scrollTo(0, 0);
  }

  markAsTouched(group: FormGroup | FormArray) {
    Object.keys(group.controls).map((field) => {
      const control = group.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAsTouched(control);
      }
    });
  }

  equalCountry(n1: CountryVM, n2: CountryVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.id === n2.id;
  }

  equalCallingCode(n1: CallingCodeVM, n2: CallingCodeVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.callingCode === n2.callingCode && n1.commonName === n2.commonName;
  }

  equalNationality(n1: NationalityVM, n2: NationalityVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.id === n2.id;
  }

  equalCounsellingTopic(n1: CounsellingTopicVM, n2: CounsellingTopicVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.id === n2.id;
  }

  equalLanguage(n1: LanguageVM, n2: LanguageVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.id === n2.id;
  }

  equalTimeZone(n1: TimeZoneInfoVM, n2: TimeZoneInfoVM) {
    if (n1 == null || n2 == null) {
      return false;
    }
    return n1.zoneName === n2.zoneName;
  }

}
